import React from "react";
import "./Achievements.css";
import { FaMedal, FaRegClock, FaLaptop, FaHandshake } from "react-icons/fa";
import CTAButton from "../CTA/CTAButton";

const achievements = [
  {
    text: "Experiência: Somos referência na luta contra abusos praticados por instituições bancárias",
    icon: <FaMedal />,
  },
  {
    text: "Eficiência: Uso das melhores estratégias jurídicas e metodologias ágeis, garantindo um processo assertivo",
    icon: <FaHandshake />,
  },
  {
    text: "Comprometimento: Mais de 12 anos de experiência no Direito para garantir que suas necessidades sejam atendidas",
    icon: <FaRegClock />,
  },
  {
    text: "Atendimento online e imediato, com profissionais especializados prontos para atender suas necessidades",
    icon: <FaLaptop />,
  },
];



const Achievements = () => {
  return (
    <section className="conquistas" id="conquistas">
      <div className="conquistas-content">
        <h1>NOSSOS DIFERENCIAIS</h1>
        <div className="conquistas-list">
          {achievements.map((achievement, index) => (
            <div className="conquistas-item" key={index}>
              <div className="conquistas-icon">{achievement.icon}</div>
              <p>{achievement.text}</p>
            </div>
          ))}
        </div>
        <CTAButton />
      </div>
    </section>
  );
};

export default Achievements;